import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { APP_NAME, IS_DIBREWORK } from "./lib/theme";

// Theme branding applied at runtime: the browser-tab title always, and the
// dibrework cup favicon only for that theme (default theme stays unbranded).
document.title = APP_NAME;
if (IS_DIBREWORK) {
  const link =
    document.querySelector<HTMLLinkElement>("link[rel='icon']") ??
    document.createElement("link");
  link.rel = "icon";
  link.type = "image/svg+xml";
  link.href = `${import.meta.env.BASE_URL}dibrework-mark.svg`;
  if (!link.parentNode) document.head.appendChild(link);
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
